import { reset } from '@formkit/core';
import { undefine, init } from '@formkit/utils';

function createLazyPlugin(LazyOptions) {
  const lazyPlugin = (node) => {
    node.addProps(["lazy"]);
    node.on("created", async () => {
      if (!undefine(node.props.lazy)) {
        return;
      }
      node.props.disabled = true;
      try {
        const lazy = node.props.lazy;
        const state = await (typeof lazy === "function" ? lazy() : lazy);
        node.props.initial = init(state);
        if (node.hook.beforeLazy.dispatch(state) !== false) {
          reset(node, state);
        }
        node.emit("lazy", state);
      } catch (error) {
        node.emit("lazy:error", error);
      } finally {
        node.props.disabled = false;
      }
    });
  };
  return lazyPlugin;
}

export { createLazyPlugin };
